/**
 * 名医推荐模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取名医推荐列表
export const goodDoctorList = (params) => {
  return req.get('/wechat/doctorRecommend/list', params);
}

// 新增名医推荐
export const goodDoctorAdd = (params) => {
  return req.post('/wechat/doctorRecommend', params);
}

// 删除名医推荐
export const goodDoctorDelete = (doctorIds) => {
  return req.delete(`/wechat/doctorRecommend/${doctorIds}`);
}

// 名医推荐排序
export const goodDoctorDragSort = (params) => {
  return req.post('/wechat/doctorRecommend/dragSort', params);
}